module.exports = __webpack_public_path__ + "img/site_23.37414570.png";